import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  AddressInput,
  AddressTypographyDiv,
  AddressTypographyTitle,
  AddressTypographySubTitle,
  DeliveryOptionsContainer,
  AddressContainer,
  BorderedContainer,
  AddressLeftContainer,
  DeliveryPriceTypography,
  DeliveryPriceContainer,
} from '../styles';
import { SubtitleTypography } from '../../styles';
import {
  InfoDiv,
  InfoIconButton,
  InfoTypography,
} from './PickUpOptions.styles';
import { useCallback } from 'react';
import { DeliveryType } from '@interfaces';
import { Skeleton } from '@mui/material';
import { GetCheckoutAddressQueryResponse } from '@queries/checkout/queries/address';
import { useWindowSize } from '@hooks/useWindowSize';
interface PickUpOptionsProps {
  currentOrder: GetCheckoutAddressQueryResponse['currentOrder'];
  onSelectOption: (deliveryType: DeliveryType) => void;
  loading: boolean;
  missingInfo: boolean;
}

export function PickUpOptions({
  currentOrder,
  onSelectOption,
  loading,
  missingInfo,
}: PickUpOptionsProps) {
  const { isMobile } = useWindowSize();
  const onChange = useCallback(() => {
    onSelectOption('PICK_UP');
  }, [onSelectOption]);

  const isPickUp = currentOrder?.deliveryType === 'PICK_UP';

  const MekiAddress = isMobile
    ? 'Av. El Salto 4001 · L8, Huechuraba.'
    : 'Av. El Salto 4001, Local 8, Huechuraba';

  const MekiHours = isMobile
    ? 'Lun a Vi de 09:00 a 18:00 hrs'
    : 'Lunes a Viernes de 09:00 a 18:00 hrs';

  return (
    <DeliveryOptionsContainer>
      <SubtitleTypography>Retiro en tienda</SubtitleTypography>
      {loading ? (
        <PickUpOptionsSkeleton />
      ) : (
        <>
          <BorderedContainer missingInfo={missingInfo}>
            <AddressContainer>
              <AddressLeftContainer>
                <AddressInput
                  type="radio"
                  name="delivery-option"
                  checked={isPickUp}
                  onChange={onChange}
                />
                <AddressTypographyDiv>
                  <AddressTypographyTitle>Farmacia Meki</AddressTypographyTitle>
                  <AddressTypographySubTitle>
                    {MekiAddress}
                  </AddressTypographySubTitle>

                  <AddressTypographySubTitle>
                    {MekiHours}
                  </AddressTypographySubTitle>
                </AddressTypographyDiv>
              </AddressLeftContainer>
              <DeliveryPriceContainer>
                <DeliveryPriceTypography>Gratis</DeliveryPriceTypography>
              </DeliveryPriceContainer>
            </AddressContainer>
          </BorderedContainer>
          {isPickUp && (
            <InfoDiv>
              <InfoIconButton>
                <InfoOutlinedIcon />
              </InfoIconButton>
              <InfoTypography>
                Te enviaremos un correo cuando tu pedido esté listo para ser
                retirado
              </InfoTypography>
            </InfoDiv>
          )}
        </>
      )}
    </DeliveryOptionsContainer>
  );
}

const PickUpOptionsSkeleton = () => (
  <BorderedContainer>
    <AddressContainer>
      <AddressLeftContainer>
        <Skeleton variant="circular" width={24} height={24} />
        <AddressTypographyDiv>
          <Skeleton variant="rounded" width={200} height={20} />
          <Skeleton variant="rounded" width={100} height={19} />
        </AddressTypographyDiv>
      </AddressLeftContainer>
      <DeliveryPriceContainer>
        <Skeleton variant="rounded" width={50} height={20} />
      </DeliveryPriceContainer>
    </AddressContainer>
  </BorderedContainer>
);
